import { useId } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

import { Button } from '@/components/ui/button'

export function AppraisalSection({
  title,
  icon: Icon,
  isOpen = true,
  onToggle,
  children,
}) {
  const panelId = useId()

  return (
    <section className="overflow-hidden rounded-xl border border-border bg-card shadow-sm">
      <Button
        type="button"
        variant="ghost"
        className="h-auto w-full justify-between rounded-none p-6 hover:bg-muted/30"
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-muted-foreground">
          {Icon ? <Icon aria-hidden="true" className="h-4 w-4" /> : null}
          {title}
        </span>
        {isOpen ? (
          <ChevronUp aria-hidden="true" className="h-4 w-4 text-muted-foreground" />
        ) : (
          <ChevronDown aria-hidden="true" className="h-4 w-4 text-muted-foreground" />
        )}
      </Button>
      <div id={panelId} hidden={!isOpen} className="px-6 pb-6">
        {children}
      </div>
    </section>
  )
}
